"use client"
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import { GlobalContext } from '../../App';
import { getHeaders, headers } from '../../http/axios';
import Pagination from '../../components/Common/pagination/Pagination';
import { useAuth } from '../../auth/AuthProvider';

export default function Category() {
    const { setSpinner } = useContext(GlobalContext);
    const imageUrl = "./assets/images/";
    // ---------- pagination
    const [page, setPage] = useState(1);
    const [paginationData, setPaginationData] = useState();
    const {token:authToken} = useAuth();
    const columns = [
        {
            name: 'S.No.',
            selector: (row, index) => index + 1,
            width: "10%",
        },
        {
            name: 'Name',
            selector: row => row.name,
            width: "40%",
            sortable: true,
        },
        {
            name: 'Created Date',
            // selector: row => row.created_at,
            selector: row => new Date(row.created_at).toLocaleDateString(),
            width: "40%",
        },
        {
            name: 'Action',
            width: "10%",
            selector: row => (
                <div className="flex items-center gap-2">
                    {/* <button><img src={imageUrl + "Trash.svg"} alt="" /></button> */}
                    <Link
                        className='ms-2'
                        to={{
                            pathname: `/category/editCategory/${row.id}`,
                        }}
                        state={{ categoryData: row }}
                    >
                        <img src={imageUrl + "PencilSquare.svg"} alt="" />
                    </Link>
                </div>
            )
        },
    ];

    const [categoryData, setCategoryData] = useState([]);
    // category data 
    const getCategory = () => {
        setSpinner(true);
        axios.get(
            `${process.env.REACT_APP_API_KEY}blog/categories`,
            { headers: getHeaders()}
        )
            .then((res) => {
                console.log(res.data);  // Debugging line
                // Adjust the path according to your API response structure
                if (Array.isArray(res.data.data)) {
                    const { current_page, last_page, per_page, total, data } = res?.data;
                    setCategoryData(data);
                    setPaginationData({ current_page, last_page, per_page, total });
                } else {
                    console.error('Expected an array but got:', res.data);
                }
            })
            .finally(() => {
                setSpinner(false);
            });
    };

    useEffect(() => {
        getCategory(page);  
    }, [page]);

    // ---------- pagination
    const handlePageClick = (data) => {
        setPage(data.selected + 1);
    };
    return (
        <>
            <div className="title flex justify-between items-center mb-5">
                <h2>Category</h2>
                <div className="flex search-dropdown gap-6">
                    {/* <div className="search-box rounded w-[400px]">
                        <img src={imageUrl + "serach.svg"} alt="" />
                        <input
                            type="search"
                            placeholder="Search Category"
                            className='w-full'
                        />
                    </div> */}
                    <Link to="/category/addCategory" className="primaryBG text-white px-8 py-3 rounded ">
                        <img src="./assets/images/plus.svg" alt="" />
                        Add
                    </Link>
                </div>
            </div>
            <div className="data-box  responsive-table cat-table">
                <DataTable
                    className='rounded-none saras-table'
                    columns={columns}
                    data={categoryData}
                />

                {paginationData?.total > 10 && <Pagination
                    pageNumber={paginationData?.from}
                    perPage={paginationData?.to}
                    paginationList={10}
                    pageRange={paginationData?.total}
                    onPageActive={paginationData?.current_page}
                    pageCount={paginationData?.last_page}
                    handlePageClick={handlePageClick}
                    paginationClass="justify-content-end st-pagin"
                />}
            </div>
        </>
    )
}
